export default {
    common: {
        select: '選擇',
        loading: '載入中',
        qty: '數量'
    },
    //component
    wineSelect: {
        title: '你會想更改禮籃內的酒嗎?',
        intro: '簡介',
        default: '預設'
    },
    addOnsSelect: {
        title: '你會想加配其他產品嗎?',
        intro: '產品簡介',
        placeholder: '請選擇',
    },
    messageInput: {
        'your_browser_does_not_support_this_feature': '您的瀏覽器不支持此功能',
        'message_input_type_1_title': '快速輸入您的信息',
        'message_input_type_1_description': '通用格式',
        'message_input_type_2_title' : '輸入並編輯您的心意卡',
        'message_input_type_2_description': '自訂格式',
        'message_overflow_warning': '偵測到內容超出了輸入範圍，可能部分內容無法顯示。如內容顯示正確，則無需理會此提示'
    },
    //store
    cart: {
        itemAddOnOrModification: '附加或更改的產品如下',
        viewCart: '查看購物車',
    }
}